import { IconAllDone } from '@consta/icons/IconAllDone'
import { Badge } from '@consta/uikit/Badge'
import { Grid, GridItem } from '@consta/uikit/Grid'
import { cnMixCard } from '@consta/uikit/MixCard'
import { Text } from '@consta/uikit/Text'
import { ObjectEntries } from 'common/helpers'
import type { FC } from 'react'
import { Fragment } from 'react'

import { dictionaryCube } from './data'
import css from './Ready.css'
import type { ReadyProps } from './types'

const dictionaryCubeEntries = ObjectEntries(dictionaryCube)

const gridWrapperClass = cnMixCard(
  {
    verticalSpace: 'm',
    horizontalSpace: 'm',
    form: 'round',
    border: true,
  },
  [css.gridWrapper],
)

export const Ready: FC<ReadyProps> = ({ item }) => {
  return (
    <div className={css.container}>
      <div className={css.geometryWrapper}>
        <Text size="s" view="secondary" className={css.headTitle}>
          Геометрия
        </Text>
        <Badge
          size="s"
          status="success"
          view="stroked"
          label="Готово к добавлению в проект"
          iconLeft={IconAllDone}
        />
      </div>
      <div className={gridWrapperClass}>
        <Grid cols={2} className={css.table}>
          {dictionaryCubeEntries.map(([key, title]) => (
            <Fragment key={key}>
              <GridItem className={css.titleWrapper}>
                <Text size="s" view="secondary">
                  {title}
                </Text>
              </GridItem>
              <GridItem className={css.itemWrapper}>
                <Text size="s" view="primary">
                  {item?.[key]}
                </Text>
              </GridItem>
            </Fragment>
          ))}
        </Grid>
      </div>
    </div>
  )
}
